import { EditComponent }                 from '../../app-lite/table/cell-components/actions/edit.component';
import { InvoiceContactStatusComponent } from '../../app-lite/invoices/contact-status/invoice.contact-status.component';
import { InvoiceReferenceComponent }     from '../../app-lite/invoices/invoice.reference.component';

export function CustomerInvoicesCtrl (
  $rootScope,
  $scope,
  $state,
  $translate,
  tableApi,
  workshopAPI
) {
  $scope.showCustomerInvoices = !!$scope.invoices.length;
  $scope.tableCacheKey        = 'customerInvoices';

  $scope.filtering = tableApi.setFiltersFromCache($scope.tableCacheKey, {
    begin_date : '',
    end_date   : '',
    reference  : '',
    status_type: '*'
  });

  $scope.tableSettings = {
    broadcast: 'filterInvoices',
    cache    : {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.REFERENCE')
        },
        component: {
          enabled: true,
          factory: InvoiceReferenceComponent
        },
      },
      {
        field : 'post_date',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'invoice_type',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.TRAN_TYPE')
        },
        pipe: 'invoiceType'
      },
      {
        field : 'invoice_status',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'invoiceStatus'
      },
      {
        field : 'cash_or_account',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.TYPE')
        },
        pipe: 'customerType'
      },
      {
        field : 'total',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      },
      {
        component: {
          enabled: true,
          factory: InvoiceContactStatusComponent
        },
        header: {
          classes: 'text-center',
          text   : $translate.instant('GENERAL_SPACE.STATUS.CONTACTED')
        },
        sortable: false
      },
      {
        classes: 'text-right',
        field  : 'balance_due',
        header : {
          classes: 'text-right',
          text   : $translate.instant('JS_SPACE.COLUMNS.BALANCE')
        },
        pipe: 'globalCurrency'
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: event => $scope.viewInvoice(event)
            }
          },
          enabled: !$scope.customer.archived,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/customers/invoice_count_with_find', [
        $scope.customer.id,
        $scope.filtering.status_type || '*',
        '*',
        $scope.filtering.begin_date || '*',
        $scope.filtering.end_date || '*',
        $scope.filtering.reference || '*'
      ])
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'desc',
      field    : 'post_date'
    }),
  };

  $scope.getInvoices = ( params ) => {
    return workshopAPI.get('/customers/invoice_list_with_find', [
      $scope.customer.id,
      params.offset,
      params.pageSize,
      $scope.filtering.status_type || '*',
      '*',
      $scope.filtering.begin_date || '*',
      $scope.filtering.end_date || '*',
      params.field,
      params.direction,
      $scope.filtering.reference || '*'
    ]).then(invoices => {
      $scope.invoices = invoices;

      return invoices;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    if ( !$scope.customer.archived ) {
      $scope.viewInvoice(event.row);
    }
  };

  $scope.viewInvoice = function (invoice) {
    if (invoice.contains_vehicle_sale) {
      $state.go('app.dealership.sale', {
        customer_id: $scope.customer.id,
        id         : invoice.id,
      });
    }
    else {
      $state.go('app.invoice', {
        customer_id: $scope.customer.id,
        id         : invoice.id,
        vehicle_id : invoice.vehicle_id
      });
    }
  };

  $scope.$watch('[ filtering.begin_date, filtering.end_date, filtering.reference, filtering.status_type ]', ( newVal, oldVal ) => {
    if (newVal !== oldVal) {
      window['filterInvoices']($scope.filtering);
    }
  }, true);
}